import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

import authRoutes from "./auth-routes";
import customerRoutes from "./customer-routes";
import commonRoutes from "./common-routes";
import customRoutes from "./custom-routes";
import nurseRoutes from "./nurse-routes";
import doctorRoutes from "./doctor-routes";
import secretaryRoutes from "./secretary-routes";
import dataShareRoutes from './data-share-routes'

Vue.use(Router);

const createRouter = () => {
    const routes = [
        ...dataShareRoutes,
        ...authRoutes,
        ...nurseRoutes,
        ...doctorRoutes,
        ...secretaryRoutes,
        ...customRoutes,
        ...customerRoutes,
        ...commonRoutes,
    ];

    const router = new Router({
        mode: "history",
        routes: routes,
    });

    return router;
};

const router = createRouter();

Router.prototype.resetRouter = function () {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // the relevant part
};

router.beforeEach((to, from, next) => {
    if (
        !to.path?.startsWith("/page/") &&
        !to.path?.startsWith("/service/") &&
        store.getters["auth/isLoggedIn"] &&
        !store.state.auth?.user
    ) {
        store
            .dispatch("auth/getProfile")
            .then((user) => {
                if (to && (to.path === "/" || to.path === "/login")) {
                    if (user.role === "customer") {
                        next({ name: "customer.schedules" });
                    } else {
                        next({ name: `${user.role}.dashboard` });}
                } else {
                    next();
                }
            })
            .catch(() => {
                next();
            });
    } else {
        next();
    }
});

export default router;
